import $ from 'jquery';
import whenDomReady from 'when-dom-ready';

import '../../styles/pages/store-locator.scss';

whenDomReady(() => {
    
});